import {autobind} from 'core-decorators';

import {Component} from 'inferno'; // eslint-disable-line @typescript-eslint/no-unused-vars
import {CustomComponent, Button} from '../components';
import emitter from '../util/emitter';

import './GoogleSigninButton.scss';


export class GoogleSigninButton extends CustomComponent {
    constructor(props: jsx.Props, context: jsx.AppGlobals) {
        super(props, context);
        if (!context.googleAuthService.scriptLoaded) {
            context.googleAuthService.load();
        }
        this.handleGoogleAuthLoadChange();
    }
    componentDidMount() {
        emitter.on('googleAuthLoadChange', this.handleGoogleAuthLoadChange);
    }
    componentWillUnmount() {
        emitter.off('googleAuthLoadChange', this.handleGoogleAuthLoadChange);
    }
    @autobind
    handleGoogleAuthLoadChange() {
        const {googleAuthService} = this.context;
        // Needed to trigger button rerender.
        this.setState({
            scriptLoaded: googleAuthService.scriptLoaded,
            errorMsg: googleAuthService.errorMsg,
        });
        if (googleAuthService.errorMsg) {
            console.error('handleGoogleAuthLoadChange', googleAuthService.errorMsg);
            this.props.failureCallback?.(googleAuthService.errorMsg, 'Google authentication failed to initialize');
            // An error was encountered, no need to listen for changes. Also
            // need to avoid potentially calling this callback twice.
            emitter.off('googleAuthLoadChange', this.handleGoogleAuthLoadChange);
        }
    }
    @autobind
    clickHandler(event: Event) {
        event.preventDefault();
        this.signInWithGoogle();
        this.props.onClick?.();
        this.context.apiService.registerEvent('google_authentication_tap', {});
    }

    @autobind
    signInWithGoogle() {
        const {googleAuthService} = this.context;
        const GoogleAuth = window.gapi.auth2.getAuthInstance();
        console.log('GoogleAuth', GoogleAuth);
        GoogleAuth.signIn(googleAuthService.getSignInOptions())
            .then(this.handleAuthResponse, this.handleAuthError);
    }

    @autobind
    handleAuthResponse(GoogleUser) {
        console.log('handleAuthResponse GoogleUser', GoogleUser);

        this.props.successCallback?.({
            GoogleUser,
        });
    }

    @autobind
    handleAuthError(error: Error) {
        console.log('handleAuthError', error);
        console.error(error);
        this.props.failureCallback?.(error, 'Google authentication error');
    }

    render() {
        const {googleAuthService} = this.context;
        const gettextSub = this.context.gtService.gettextSub;
        return (
            <div className="GoogleSigninButton">
                <label className="hidden" htmlFor='google-auth-button'>
                    {gettextSub('Sign in with Google')}
                </label>
                <Button
                    name='google-auth-button'
                    type='button'
                    clickLabel='log-in-google'
                    onClick={this.clickHandler}
                    disabled={
                        !googleAuthService.scriptLoaded || this.props.disabled}
                />
            </div>
        );
    }
}
